import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <h4>J3 Innovations</h4>
          <p>
            Houses aren’t hobbies. We build wall systems that respect the craft.
          </p>
        </div>
        <div className="footer-columns">
          <div>
            <p className="footer-label">Contact</p>
            <p>info@j3xinnovation.com</p>
            <p>(281) 857-5307</p>
          </div>
          <div>
            <p className="footer-label">Service Area</p>
            <p>Houston · Austin</p>
          </div>
          <div>
            <p className="footer-label">Links</p>
            <p>Interior Decals · Fast Flash · Texture Lab (soon)</p>
          </div>
        </div>
        <div className="footer-meta">
          © 2024 J3 Innovations. Houses aren’t hobbies.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
